/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ caseNumber: NonNullable<unknown> }} Notifications_Task_Sla_Breach_BodyInputs */

const en_notifications_task_sla_breach_body = /** @type {(inputs: Notifications_Task_Sla_Breach_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A task on case ${i?.caseNumber} has passed its SLA.`)
};

const pt_br2_notifications_task_sla_breach_body = /** @type {(inputs: Notifications_Task_Sla_Breach_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uma atividade no caso ${i?.caseNumber} ultrapassou o SLA.`)
};

/**
* | output |
* | --- |
* | "A task on case {caseNumber} has passed its SLA." |
*
* @param {Notifications_Task_Sla_Breach_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_sla_breach_body = /** @type {((inputs: Notifications_Task_Sla_Breach_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Sla_Breach_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_sla_breach_body(inputs)
	return pt_br2_notifications_task_sla_breach_body(inputs)
});